import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function B38({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.SIC01.error_id: {
            return (
                <>
                    <ResultText>
                        Set Internal Changes in WSEL is defined at the following cross sections.
                        <EmptyLine />
                        <CheckCSName csNameList={row?.data?.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
    }
}